import { render, staticRenderFns } from "./PDFServicePartsProtocol.vue?vue&type=template&id=0a2c98c2&scoped=true&"
import script from "./PDFServicePartsProtocol.vue?vue&type=script&lang=js&"
export * from "./PDFServicePartsProtocol.vue?vue&type=script&lang=js&"
import style0 from "./PDFServicePartsProtocol.vue?vue&type=style&index=0&id=0a2c98c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c98c2",
  null
  
)

export default component.exports